import { Link } from '@tanstack/react-router';
import type { ImportCap } from '@/components/search/table/import-cap.util';

/** The one line under an import's count picker: a plan's limit and the way to
 *  the plans page, and with showCeiling what a single import adds. */
export function ImportCapNotice({
  cap,
  byPlan,
  onUpgrade,
  showCeiling = false,
}: ImportCap & { onUpgrade?: () => void; showCeiling?: boolean }) {
  // In the Add popovers the per-import ceiling says itself when Custom hits
  // it; only a plan's limit, which an upgrade lifts, earns a line there.
  if (!byPlan && !showCeiling) return null;
  return (
    <p className='flex items-center gap-1.5 text-[12px] text-muted-foreground'>
      <span>
        {byPlan
          ? `Your plan adds up to ${cap.toLocaleString()} per list`
          : `Adds up to ${cap.toLocaleString()} at a time`}
      </span>
      {byPlan && (
        <Link
          to='/plans'
          search={{
            status: undefined,
            credits_added: undefined,
            plan_name: undefined,
          }}
          onClick={onUpgrade}
          className='font-medium text-primary hover:underline'
        >
          Upgrade
        </Link>
      )}
    </p>
  );
}
